import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="border-y border-line py-6 bg-ink">
      <Marquee speed={30} gradient={false} autoFill>
        {t.marquee.map((w) => (
          <span key={w} className="flex items-center">
            <span className="font-heading font-bold text-2xl md:text-4xl tracking-tight text-line mx-8">{w}</span>
            <span className="text-volt text-2xl md:text-4xl mx-2">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export const CertsMarquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="certs-marquee" className="border-y border-line py-5 bg-graphite">
      <Marquee speed={60} gradient={false} autoFill direction="right">
        {t.certs.map((c) => (
          <span key={c} className="mx-6 flex items-center gap-6">
            <span className="font-mono text-xs md:text-sm uppercase tracking-[0.25em] text-paper">{c}</span>
            <span className="w-1.5 h-1.5 bg-volt inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
